import {
  SourceEntityMigrationType,
  type ISourceEntity,
  ISourceEntityTypes,
} from '@principle-theorem/practice-migrations/interfaces';
import { TypeGuard, type Timezone } from '@principle-theorem/shared';
import { BaseSourceEntity } from '../../../source/base-source-entity';
import { SourceEntity } from '../../../source/source-entity';
import { CorePracticeMediaCategory } from './patient-media';

export const PATIENT_MEDIA_CATEGORY_RESOURCE_TYPE = 'patientMediaCategory';

export const PATIENT_MEDIA_CATEGORY_SOURCE_ENTITY: ISourceEntity =
  SourceEntity.init({
    metadata: {
      label: 'Patient Media Category List',
      description: '',
      idPrefix: PATIENT_MEDIA_CATEGORY_RESOURCE_TYPE,
      migrationType: SourceEntityMigrationType.Automatic,
    },
  });

export interface ICorePracticePatientMediaCategory {
  id: CorePracticeMediaCategory;
}

export function isCorePracticeMediaCategory(
  item: unknown,
  logError: boolean
): item is ICorePracticePatientMediaCategory {
  return TypeGuard.interface<ICorePracticePatientMediaCategory>(
    {
      id: TypeGuard.enumValue(CorePracticeMediaCategory),
    },
    logError
  )(item);
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ICorePracticePatientMediaTranslations {}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ICorePracticePatientMediaFilters {}

const PATIENT_MEDIA_CATEGORY_SOURCE_QUERY = `
SELECT
  CategoryId AS id
FROM tblMedia
WHERE CategoryId IS NOT NULL
GROUP BY CategoryId
`;

export type CorePracticePatientMediaCategory = ISourceEntityTypes<
  ICorePracticePatientMediaCategory,
  ICorePracticePatientMediaTranslations,
  ICorePracticePatientMediaFilters
>;

export class PatientMediaCategorySourceEntity extends BaseSourceEntity<CorePracticePatientMediaCategory> {
  sourceEntity = PATIENT_MEDIA_CATEGORY_SOURCE_ENTITY;
  entityResourceType = PATIENT_MEDIA_CATEGORY_RESOURCE_TYPE;
  sourceQuery = PATIENT_MEDIA_CATEGORY_SOURCE_QUERY;
  verifySourceFn = isCorePracticeMediaCategory;

  translate(
    _data: ICorePracticePatientMediaCategory,
    _timezone: Timezone
  ): object {
    return {};
  }

  getSourceRecordId(data: ICorePracticePatientMediaCategory): number {
    return data.id;
  }

  getSourceLabel(data: ICorePracticePatientMediaCategory): string {
    return data.id.toString();
  }

  getFilterData(
    _data: ICorePracticePatientMediaCategory,
    _timezone: Timezone
  ): object {
    return {};
  }
}
